import PengirimanDashboard from "../views/Dashboard/PengirimanDashboard";
// import HomeSalesReport from "../views/report/sales";
// import HomeShipmentReport from "../views/report/shipment";
// import HomeExportReport from "../views/report/export";
// import HomeMarketingReport from "../views/marketing/home";
// import HomeCustomerGrowthReport from "../views/report/customerGrowth";
// import HomeMarketingGeneralReport from "../views/marketing/general";
// import ListClaim from "../views/claim/list";
// import DetailClaim from "../views/claim/detail";
import MonitorItem from '../views/item/monitor';
import QCItem from '../views/qc/item/detail';
import QCStuffing from '../views/qc/stuffing/detail';
import QCSurface from '../views/qc/surface/update';
import RekapQc from '../views/qc/report/rekap';

var dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "pe-7s-graph",
    component: PengirimanDashboard,
  },
  {
    collapse: true,
    path: "/item",
    name: "Item",
    state: "openItem",
    icon: "pe-7s-notebook",
    modul: "item",
    modulAction: "VIEW",
    views: [
      // {
      //   path: "/item/list/detail/:id",
      //   name: "Detail",
      //   hidden: true,
      //   component: DetailClaim,
      // },
      {
        path: "/item/list",
        name: "List",
        mini: "I",
        component: MonitorItem,
      },
    ],
  },
  {
    collapse: true,
    path: "/qc",
    name: "Qc",
    state: "openQc",
    icon: "pe-7s-notebook",
    modul: "qc",
    modulAction: "VIEW",
    views: [
      {
        path: "/qc/dimension",
        name: "Dimension",
        mini: "D",
        component: QCItem,
      },
      {
        path: "/qc/surface",
        name: "Surface",
        mini: "S",
        component: QCSurface,
      },
    ],
  },
  {
    collapse: true,
    path: "/shipment",
    name: "Shipment",
    state: "openShipment",
    icon: "pe-7s-notebook",
    modul: "stuffing",
    modulAction: "VIEW",
    views: [
      // {
      //   path: "/item/list/detail/:id",
      //   name: "Detail",
      //   hidden: true,
      //   component: DetailClaim,
      // },
      {
        path: "/shipment/stuffing",
        name: "Stuffing",
        mini: "S",
        component: QCStuffing,
      },
    ],
  },
  {
    path: "/report",
    name: "Qc-Export",
    modul: "qc",
    modulAction: "VIEW",
    icon: "pe-7s-graph",
    component: RekapQc,
  },
  // {
  //   path: "/export",
  //   name: "Export",
  //   icon: "pe-7s-notebook",
  //   component: HomeExportReport,
  // },
  {
    redirect: true,
    pathTo: "/dashboard",
    component: PengirimanDashboard,
    name: "Dashboard",
  },
];
export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx